import React from 'react';

import QuestionHOC from './QuestionHOC';

export default function FirstName({ item, index }) {
  const displayQuestion = () => {
    if (item.hasOwnProperty('onlyAnswer') && item.onlyAnswer === true) {
      return <div className="col">Jane</div>

    } else {
      return <>
        <div className="col-8">First Name</div>
        <div className="col-4">Jane</div>
      </>
    }
  }

  return <QuestionHOC item={item} index={index}>
    <div className="row">
      {displayQuestion()}
    </div>
  </QuestionHOC>
}